import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5005/api/';

// --- Свой http-instance (рекомендован для нового кода) ---
const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
});

// --- Ссылка на UserStore (инжектится из index.js, чтобы избежать цикла) ---
let _userStoreRef = null;
export const bindUserStore = (store) => {
  _userStoreRef = store;
  applyGlobalAxiosInterceptors();
};

let _onUnauthorized = null;
export const onUnauthorized = (fn) => { _onUnauthorized = fn; };

// --- Общая логика интерсепторов ---
function attachAuthHeader(cfg) {
  // удалить устаревший заголовок, если кто-то ещё передаёт
  if (cfg.headers && cfg.headers['x-api-key']) delete cfg.headers['x-api-key'];
  const token = _userStoreRef?.accessToken;
  if (token) {
    if (!cfg.headers) cfg.headers = {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  // withCredentials по умолчанию true, чтобы refresh-cookie ходил
  if (typeof cfg.withCredentials === 'undefined') cfg.withCredentials = true;
  return cfg;
}

let refreshing = null;
async function handle401(error, instance) {
  const { response, config } = error;
  if (!response || response.status !== 401 || config?._retry) {
    return Promise.reject(error);
  }
  const url = String(config?.url || '');
  if (url.includes('/v1/login') || url.includes('/v1/refresh') || url.includes('/v1/logout')) {
    return Promise.reject(error);
  }
  if (!refreshing) {
    refreshing = axios.post(`${BASE}v1/refresh`, {}, { withCredentials: true })
      .then((r) => r.data.accessToken)
      .finally(() => { setTimeout(() => { refreshing = null; }, 0); });
  }
  try {
    const newToken = await refreshing;
    _userStoreRef?.setAccessToken(newToken);
    config._retry = true;
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${newToken}`;
    return instance.request(config);
  } catch {
    _userStoreRef?.logout();
    if (_onUnauthorized) _onUnauthorized();
    return Promise.reject(error);
  }
}

// --- На своём api-инстансе ---
api.interceptors.request.use(attachAuthHeader);
api.interceptors.response.use((r) => r, (e) => handle401(e, api));

// --- На глобальном axios — чтобы старый код работал без правок ---
let _globalAttached = false;
function applyGlobalAxiosInterceptors() {
  if (_globalAttached) return;
  _globalAttached = true;
  axios.interceptors.request.use(attachAuthHeader);
  axios.interceptors.response.use((r) => r, (e) => handle401(e, axios));
  patchGlobalFetch();
}

// --- Monkey-patch для window.fetch (часть legacy-кода использует fetch напрямую) ---
function patchGlobalFetch() {
  if (typeof window === 'undefined' || window.__mb4FetchPatched) return;
  window.__mb4FetchPatched = true;
  const origFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url;
    const isApi = typeof url === 'string' && (url.startsWith(BASE) || url.includes('/api/v1/'));
    if (!isApi) return origFetch(input, init);

    const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined) || {});
    headers.delete('x-api-key');
    const token = _userStoreRef?.accessToken;
    if (token) headers.set('Authorization', `Bearer ${token}`);

    const newInit = { ...init, headers, credentials: init.credentials || 'include' };
    const res = await origFetch(input, newInit);

    if (res.status === 401 && !newInit._retry && !url.includes('/v1/login') && !url.includes('/v1/refresh')) {
      try {
        if (!refreshing) {
          refreshing = axios.post(`${BASE}v1/refresh`, {}, { withCredentials: true })
            .then((r) => r.data.accessToken)
            .finally(() => { setTimeout(() => { refreshing = null; }, 0); });
        }
        const newToken = await refreshing;
        _userStoreRef?.setAccessToken(newToken);
        headers.set('Authorization', `Bearer ${newToken}`);
        return origFetch(input, { ...newInit, _retry: true, headers });
      } catch {
        _userStoreRef?.logout();
        if (_onUnauthorized) _onUnauthorized();
      }
    }
    return res;
  };
}

export default api;
